import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class FinanceNotificationHeader extends EntityBase {
  public HrmPersonnelId: number;
  public IsGroupedIssue: boolean;
  public StatuteNumber: string;
  public IssueDate: Date;
  public EffectDate: Date;
  public Description: string;
  public IssueYear: number;
  public IssueMonth: number;
  public IssueDay: number;
  public EffectYear: number;
  public EffectMonth: number;
  public EffectDay: number;
  public EffectYearMonth: number;
  public OEGrpStatuteId: number;
  public FinanceNotificationDetails: FinanceNotificationDetail[];
}
export class FinanceNotificationDetail extends EntityBase {
  public FinanceNotificationHeaderId: number;
  public ElementGroupId: number;
  public ElementGroupTitle: string;
  public ElementGroupCode?: number;
  public ElementKindCode?: number;
  public ElementId: number;
  public ElementTitle: string;
  public EffectDate: Date;
  public Amount: number;
  public MonthAmount: number;
  public DayAmount: number;
  public HourAmount: number;
}
